module.exports = __webpack_public_path__ + "static/media/LightBulbRed.f0da5080.svg";